DateTimePickerDirective.$inject = ['$timeout'];
export default function DateTimePickerDirective($timeout) {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            format: "@",
            pickTime: "=",
            minDate: "=",
            maxDate: "="
        },
        link: function (scope, element, attrs, ngModelCtrl) {
            var datepicker = null;
            $(function () {
                scope.$evalAsync(function () {
                    if (typeof scope.pickTime == "undefined") scope.pickTime = false;

                    if (typeof scope.format == "undefined") {
                        if (scope.pickTime)
                            scope.format = "dd/mm/yyyy hh:ii";
                        else
                            scope.format = "dd/mm/yyyy";
                    }

                    function actualizarDatepicker() {
                        if (datepicker)
                            element.fdatepicker('update', ngModelCtrl.$viewValue);
                    }

                    ngModelCtrl.$render = actualizarDatepicker;

                    $timeout(function () {
                        var opciones =
                            {
                                format: scope.format,
                                disableDblClickSelection: true,
                                pickTime: scope.pickTime,
                                language: Sigo.var.langLocale
                            };
                        if (ngModelCtrl.$viewValue)
                            opciones.initialDate = ngModelCtrl.$viewValue;
                        if (scope.minDate)
                            opciones.startDate = scope.minDate;
                        if (scope.maxDate)
                            opciones.endDate = scope.maxDate;

                        datepicker = element.fdatepicker(opciones);
                    });
                });
            });
        }
    }
}